// src/pages/VieClub/CreateArticleModal.jsx
import React, { useState } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import { addArticle } from "./../../services/vieclubServices";
import { sendNotificationToAdmin } from "../../services/notificationServices";
import { useUser } from "./../../contexts/UserContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateArticleModal = ({ isOpen, onClose, refreshList }) => {
  const { user } = useUser();
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    club: "",
    date_article: new Date().toISOString().split("T")[0],
    photo_url1: "",
    photo_url2: "",
    photo_url3: "",
    lien_url: "",
    is_active: true,
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleContentChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addArticle({ ...formData, user_id: user.userId });
      const message = `${user.nom} ${user.prenom} a créé un nouvel article de club : ${formData.title}`;
      await sendNotificationToAdmin(message, user.token);
      await refreshList();
      onClose();
      setFormData({
        title: "",
        content: "",
        club: "",
        date_article: new Date().toISOString().split("T")[0],
        photo_url1: "",
        photo_url2: "",
        photo_url3: "",
        lien_url: "",
        is_active: true,
      });
    } catch (error) {
      console.error("Erreur lors de la création de l'article", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="w-full max-w-3xl bg-slate-50 dark:bg-slate-900 rounded-2xl shadow-2xl p-4 sm:p-6 max-h-[90vh] overflow-y-auto border border-slate-200/80 dark:border-slate-700/80">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg sm:text-xl font-bold uppercase tracking-[0.22em] text-white px-3 py-2 rounded-md bg-primary shadow font-montserrat">
            Créer un Article
          </h3>
          <Button
            text=""
            icon={FaTimes}
            onClick={onClose}
            type="button"
            className="btn-ghost btn-sm"
          />
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
                Titre
              </label>
              <input
                type="text"
                name="title"
                placeholder="Titre de l'article"
                value={formData.title}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
                required
              />
            </div>

            <div>
              <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
                Club
              </label>
              <input
                type="text"
                name="club"
                placeholder="Nom du club"
                value={formData.club}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
                required
              />
            </div>

            <div>
              <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
                Date de l&apos;article
              </label>
              <input
                type="date"
                name="date_article"
                value={formData.date_article}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              />
            </div>

            <div className="flex items-center mt-2 md:mt-7">
              <label className="label cursor-pointer flex items-center gap-2 text-xs sm:text-sm text-slate-700 dark:text-slate-200">
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      is_active: e.target.checked,
                    }))
                  }
                  className="toggle toggle-primary toggle-sm"
                />
                <span>Afficher sur la page</span>
              </label>
            </div>
          </div>

          <div>
            <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
              Contenu de l&apos;article
            </label>
            <div className="rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
              <ReactQuill
                value={formData.content}
                onChange={handleContentChange}
                theme="snow"
                placeholder="Racontez votre événement, vos résultats, etc."
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
                Photo 1
              </label>
              <input
                type="url"
                name="photo_url1"
                placeholder="URL de la photo 1"
                value={formData.photo_url1}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              />
            </div>
            <div>
              <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
                Photo 2 (facultative)
              </label>
              <input
                type="url"
                name="photo_url2"
                placeholder="URL de la photo 2"
                value={formData.photo_url2}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              />
            </div>
            <div>
              <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
                Photo 3 (facultative)
              </label>
              <input
                type="url"
                name="photo_url3"
                placeholder="URL de la photo 3"
                value={formData.photo_url3}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              />
            </div>
          </div>

          <div>
            <label className="label text-xs font-semibold text-slate-600 dark:text-slate-200">
              Lien URL (article, site, réseaux sociaux)
            </label>
            <input
              type="text"
              name="lien_url"
              placeholder="https://…"
              value={formData.lien_url}
              onChange={handleChange}
              className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
            />
          </div>

          <div className="flex justify-center gap-2 pt-2">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              type="button"
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateArticleModal;
